import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-white">
              Superbuy <span className="text-accent-400">Spreadsheet</span>
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              Your trusted source for curated superbuy spreadsheets, buying guides, and shopping resources. Helping international buyers find the best products since 2024.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">Categories</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Shoes</a>
              <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Hoodies / Sweaters</a>
              <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">T-Shirts</a>
              <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Jackets</a>
              <a href="https://kaspreadsheet.com/category-921-Bags.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Bags</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">Guides &amp; Blog</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/what-is-superbuy-spreadsheet" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">What Is a Superbuy Spreadsheet?</Link>
              <Link to="/how-to-use-superbuy-spreadsheet" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">How to Use Superbuy Spreadsheet</Link>
              <Link to="/best-superbuy-spreadsheet-sneakers" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Best Sneakers Spreadsheet</Link>
              <Link to="/how-safe-is-superbuy" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Superbuy Safety Guide</Link>
              <Link to="/#guides" className="text-sm text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap">All Guides &rarr;</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Buy It Now</a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap">Kaspreadsheet Main Site &rarr;</a>
              <Link to="/" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Home</Link>
              <Link to="/#categories" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Categories</Link>
              <Link to="/#guides" className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap">Blog</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center border border-background-600 rounded-lg text-background-300 hover:text-white hover:border-background-400 transition-colors">
              <i className="ri-shopping-cart-line"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center border border-background-600 rounded-lg text-background-300 hover:text-white hover:border-background-400 transition-colors">
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}